import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './AboutUs.css';
import Spacer from '../components/Spacer';

const AboutUs = () => {
  return (
    <div className="page-wrapper">
      <Header />

      <main className="about-us-container">
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-content">
            <h1>شرکت تولیدی و صنعتی ویدا</h1>
            <p>پیشگام در ارائه راهکارهای هوشمند از سال ۱۳۹۸</p>
          </div>
        </section>

        {/* Main Content */}
        <section className="about-main">
          <div className="about-intro">
            <p className="intro-text">
              مجموعه صنعتی ویدا از سال ۱۳۹۸ با هدف ارائه راهکارهای نوین در حوزه تجهیزات هوشمند و فناوری‌های صنعتی فعالیت خود را آغاز کرده است. این مجموعه با اتکا به دانش فنی، نیروی انسانی متخصص و تمرکز بر کیفیت و نوآوری، توانسته گام‌های مؤثری در مسیر رشد و توسعه صنعتی کشور بردارد.
            </p>
            <Spacer height={10} />
            <p className="intro-text">
              ما بر این باوریم که تولید محصولات باکیفیت و ارائه خدمات حرفه‌ای، تنها در سایه به‌روزرسانی مستمر، خلاقیت و توجه به نیازهای مشتریان محقق می‌شود.
            </p>
            <Spacer height={10} />
            <p className='intro-text'>
              در مسیر گسترش فعالیت‌ها و ارتقاء سطح توانمندی‌های خود، مشتاق همکاری با افرادی هستیم که به پیشرفت فردی و حرفه‌ای اهمیت می‌دهند و برای ساخت آینده‌ای بهتر در صنعت، انگیزه و تلاش دارند.
            </p>
          </div>

          {/* Features Grid */}
          <div className="features-grid">
            <div className="feature-card">
              <h3>هویت ما</h3>
              <p>طراحی و تولید تجهیزات هوشمند با تمرکز بر کیفیت، نوآوری و اعتماد.</p>
            </div>
            <div className="feature-card">
              <h3>مسیر رشد</h3>
              <p>آغاز فعالیت از سال ۱۳۹۸ با هدف تحول در صنعت و حرکت به‌سوی آینده‌ای هوشمند.</p>
            </div>
            <div className="feature-card">
              <h3>ارزش های ما</h3>
              <p>تعهد، خلاقیت، دانش‌محوری و پاسخ‌گویی دقیق به نیازهای مشتریان.</p>
            </div>
            <div className="feature-card">
              <h3>نگاه به آینده</h3>
              <p>دعوت به همکاری با افراد توانمند برای توسعه فردی و پیشرفت جمعی.</p>
            </div>
          </div>

          {/* Detailed Content */}
          <div className="about-content">
            <div className="content-section">
              <h2>محصولات و خدمات</h2>
              <p>
                محصولات ویدا با تمرکز بر فناوری روز و نیاز بازار، در حوزه‌ های «کنترل تردد» ، «گجت های هوشمند نورپردازی» ، «خانه هوشمند» و  «اتوماسیون صنعتی» طراحی و تولید می‌شوند.
              </p>
              <p>
                در بخش کنترل تردد، ویدا مجموعه‌ای از سیستم‌های پیشرفته شامل اکسس کنترل‌های لمسی و تگی برای آسانسور، درب ورودی ساختمان، پارکینگ‌ها و باشگاه‌ها را ارائه می‌دهد؛ راهکارهایی دقیق و مطمئن برای مدیریت تردد با نهایت امنیت و سهولت.
              </p>
              <p>
              در حوزه‌ی نورپردازی هوشمند، ویدا با طراحی محصولاتی نوآورانه نظیر وال‌واشرهای آدرس‌پذیر، نوارهای RGB و ARGB، کنترلرهای هوشمند و دستگاه V-light، جلوه‌ای مدرن و حرفه‌ای به فضاهای داخلی و خارجی می‌بخشد. این محصولات، ترکیبی از زیبایی بصری و کنترل دیجیتال را در اختیار کاربران قرار می‌دهند.
              </p>
            </div>

            <div className="content-section">
              <h2>تکنولوژی و نوآوری</h2>
              <p>
                شرکت ویدا با رویکردی نوآورانه، در مسیر توسعه‌ی فناوری‌های بومی‌سازی‌شده حرکت کرده و همواره تلاش دارد تا با ارائه‌ی محصولاتی با کیفیت و عملکرد بالا، به ارتقای امنیت، رفاه و هوشمندی در محیط‌های مختلف کمک کند.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;